module.exports = __webpack_public_path__ + "img/start.8942873e.png";